import { render, staticRenderFns } from "./ContactInformation.vue?vue&type=template&id=3ed6db6c&scoped=true"
import script from "./ContactInformation.vue?vue&type=script&lang=js"
export * from "./ContactInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed6db6c",
  null
  
)

export default component.exports